import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { translations, pickBilingual } from "../../lib/i18n";
import { TEST_IDS } from "../../constants/testIds";

const Timeline = ({ clubs = [] }) => {
  const { lang } = useLang();
  const t = translations[lang].career;

  return (
    <section
      id="career"
      data-testid={TEST_IDS.career.root}
      className="rp-section bg-[color:var(--rp-bg)]"
    >
      <div className="rp-container">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 lg:col-span-5">
            <div className="rp-eyebrow mb-4">03 · {t.eyebrow}</div>
            <h2 className="rp-heading rp-headline">{t.title}</h2>
          </div>
          <div className="col-span-12 lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="rp-lede">{t.subtitle}</p>
          </div>
        </div>

        <div className="relative">
          <div className="timeline-line" aria-hidden />
          <ul className="space-y-10">
            {clubs.map((club, i) => (
              <motion.li
                key={club.id || i}
                data-testid={TEST_IDS.career.card(i)}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="relative pl-10 md:pl-16"
              >
                <span className="absolute left-[3px] top-3 w-3 h-3 border border-[color:var(--rp-accent)] bg-[color:var(--rp-bg)]" />
                <div className="rp-card p-6 md:p-8 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8">
                  <div className="md:col-span-3 flex md:flex-col justify-between md:justify-start gap-2">
                    <div className="font-display font-bold text-[color:var(--rp-accent)] text-lg tracking-wider">
                      {club.period}
                    </div>
                    <div className="text-[11px] uppercase tracking-[0.22em] text-[color:var(--rp-muted)]">
                      {pickBilingual(club.competition, lang)}
                    </div>
                  </div>
                  <div className="md:col-span-9">
                    <div className="flex items-center gap-4">
                      {club.logo_url && (
                        <img
                          src={club.logo_url}
                          alt={`${club.name} logo`}
                          className="w-10 h-10 object-contain"
                          loading="lazy"
                        />
                      )}
                      <h3 className="font-display font-bold text-white text-xl md:text-2xl tracking-tight">
                        {club.name}
                      </h3>
                    </div>
                    {pickBilingual(club.achievements, lang) && (
                      <p className="mt-4 text-[color:var(--rp-muted)] text-[14px] leading-relaxed max-w-[62ch]">
                        {pickBilingual(club.achievements, lang)}
                      </p>
                    )}
                  </div>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Timeline;
